import { Delete, Remove } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useState } from "react";
import { ConfirmModal } from "./confirmModal";

export interface RemoveButtonProps {
  title: string;
  message: string;
  icon?: JSX.Element;
  onRemove?: () => void;
}
export const RemoveButton: React.FC<RemoveButtonProps> = ({ title, message, icon, onRemove }) => {
  const [open, setOpen] = useState(false);

  return <>
    <ConfirmModal
      open={open}
      title={title}
      message={message}
      onConfirm={() => {
        if (onRemove) onRemove();
        setOpen(false);
      }}
      onCancel={() => setOpen(false)}
    />
    <IconButton onClick={() => setOpen(true)}>
      {icon ?? <Delete />}
    </IconButton>
  </>;
};